import {ThemeIconKey} from 'platform/foundation';
import {match} from 'ts-pattern';

import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

import {AuctionTypeFilter} from '../types/AuctionTypeFilter';

type AuctionTypePresentation = {
  label: string;
  compactLabel: string;
  icon: ThemeIconKey;
  description: string;
  labelTestIdSuffix: string | null;
};

export function getAuctionTypePresentation(auctionType: string | Nullish) {
  return match(auctionType?.toLowerCase())
    .returnType<AuctionTypePresentation | null>()
    .with(AuctionTypeFilter.OPEN, () => ({
      label: i18n.t('entity.auction.labels.openAuction'),
      compactLabel: i18n.t('entity.auction.labels.open'),
      icon: 'action/gavel',
      labelTestIdSuffix: 'openFlag',
      description: i18n.t('entity.auction.labels.openAuctionDescription'),
    }))
    .with(AuctionTypeFilter.HIDDEN, () => ({
      label: i18n.t('entity.auction.labels.hiddenAuction'),
      compactLabel: i18n.t('entity.auction.labels.hiddenAuction'),
      icon: 'content/mail',
      labelTestIdSuffix: 'hiddenFlag',
      description: i18n.t('entity.auction.labels.sealedBidExplanation'),
    }))
    .with(AuctionTypeFilter.BUY_NOW, () => ({
      label: i18n.t('entity.auction.labels.buyNow'),
      compactLabel: i18n.t('entity.auction.labels.buyNow'),
      icon: 'action/shopping_cart',
      labelTestIdSuffix: null,
      description: i18n.t('entity.auction.labels.buyNowTooltip'),
    }))
    .otherwise(() => null);
}
